<div *ngIf="show" class="assurant-loader-wraper">
  <div class="assurant-loader"></div>
</div>